import { ChangeDetectionStrategy, Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { IconComponent } from '@libs/components/icons';
import { ButtonStyle, ButtonType } from '@libs/common/models';
import { ComponentsIconsStyle, IconName } from '@libs/shared/models';
import { ButtonComponent } from '../button';

@Component({
  selector: 'ui-split-button',
  imports: [
    ButtonComponent,
    IconComponent,
  ],
  templateUrl: './split-button.component.html',
  styleUrl: './split-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SplitButtonComponent {
  public primaryClicked: OutputEmitterRef<void> = output();
  public secondaryClicked: OutputEmitterRef<void> = output();

  public type: InputSignal<ButtonType> = input<ButtonType>('button');
  public buttonStyle: InputSignal<ButtonStyle> = input<ButtonStyle>('filled');
  public disabled: InputSignal<boolean> = input<boolean>(false);
  public loading: InputSignal<boolean> = input<boolean>(false);

  public icon: InputSignal<IconName> = input.required();
  public iconStyle: InputSignal<ComponentsIconsStyle> = input<ComponentsIconsStyle>('solid');
}
